import Swal from 'sweetalert2';

const alert = Swal.mixin({});

export const Alert = (type = "info", message = '', duration = 6000) => {

    alert.fire({
        icon: type,
        title: message,
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: duration,
        timerProgressBar: true,
        iconColor: 'white',
        customClass: {
            popup: 'onsc-toast__popup',
            container: 'onsc-toast',
        },
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
            toast.addEventListener('click', Swal.close);
        },
    });
};
